import { usePowerApps } from '@/context';
import { keys } from 'lodash/fp';
import { useCallback } from 'react';

export const serializeQueryParams = (obj: any) => {
  const str: string[] = [];
  keys(obj).forEach((key: string) => {
    if (obj[key]) {
      // str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
      str.push(`${key}=${obj[key]}`);
    }
  });
  return str.join('&');
};

export const useWindowLocation = () => {
  const { persistedQueryParams } = usePowerApps();

  const addQueryParams = useCallback(
    (paramsObject: any, action: 'push' | 'replace' = 'replace') => {
      const url = serializeQueryParams(paramsObject)
        ? `?${serializeQueryParams(paramsObject)}`
        : '';
      const originalUrl = window.location.origin + window.location.pathname;
      if (action === 'push') {
        window.history.pushState({}, '', url || originalUrl);
      } else {
        window.history.replaceState({}, '', url || originalUrl);
      }
      Promise.resolve().then(() => {
        persistedQueryParams.setQueryParams({ search: url });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return { addQueryParams };
};
